import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4543e5e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "form-content"
}
const _hoisted_2 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_3 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Billede af stedet:", -1))
const _hoisted_5 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_spinner = _resolveComponent("b-spinner")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_select_image_modal = _resolveComponent("select-image-modal")!
  const _component_b_img = _resolveComponent("b-img")!
  const _component_b_form = _resolveComponent("b-form")!
  const _component_b_offcanvas = _resolveComponent("b-offcanvas")!

  return (_openBlock(), _createBlock(_component_b_offcanvas, {
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.show) = $event)),
    title: `Opdatér Tur`
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_b_spinner, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_b_form, { onSubmit: _ctx.updateTrip }, {
              default: _withCtx(() => [
                _createVNode(_component_b_form_group, { label: "År" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_form_input, {
                      modelValue: _ctx.editableTrip.year,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editableTrip.year) = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_form_group, { label: "Lokation" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_form_input, {
                      modelValue: _ctx.editableTrip.location,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editableTrip.location) = $event)),
                      text: "text"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_form_group, { label: "Adresse" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_form_input, {
                      modelValue: _ctx.editableTrip.address,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editableTrip.address) = $event)),
                      text: "text"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_form_group, { label: "Beskrivelse" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_form_textarea, {
                      modelValue: _ctx.editableTrip.description,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editableTrip.description) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_button, { onClick: _ctx.changeCoverImage }, {
                      default: _withCtx(() => [
                        _createTextVNode("Skift Coverbillede")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_select_image_modal, {
                      "show-modal": _ctx.showChangeCoverImageModal,
                      "onUpdate:showModal": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showChangeCoverImageModal) = $event)),
                      title: 'Vælg coverbillede',
                      images: _ctx.images,
                      onSelected: _ctx.setCoverImage
                    }, null, 8, ["show-modal", "images", "onSelected"]),
                    (_ctx.editableTrip.coverImageId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                          _createVNode(_component_b_img, {
                            class: "image-preview",
                            src: _ctx.coverImageUri + '?' + _ctx.token
                          }, null, 8, ["src"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_form_group, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_button, { onClick: _ctx.changeLocationImage }, {
                      default: _withCtx(() => [
                        _createTextVNode("Skift billede af stedet")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_select_image_modal, {
                      "show-modal": _ctx.showChangeLocationImageModal,
                      "onUpdate:showModal": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showChangeLocationImageModal) = $event)),
                      title: 'Vælg billede af stedet',
                      images: _ctx.images,
                      onSelected: _ctx.setLocationImage
                    }, null, 8, ["show-modal", "images", "onSelected"]),
                    (_ctx.editableTrip.locationImageId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _hoisted_4,
                          _createVNode(_component_b_img, {
                            class: "image-preview",
                            src: _ctx.locationImageUri + '?' + _ctx.token
                          }, null, 8, ["src"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (_ctx.error)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.error), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_b_button, {
                  class: "submit-button",
                  size: "lg",
                  type: "submit",
                  variant: "success"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Opdatér")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ]))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}